import { api } from 'boot/axios.js'

export async function save(ctx, data) {
  try {
    const response = await api({
      url: '/shopping-carts',
      data: data,
      method: 'POST'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    return e
  }
}
